import _ from 'lodash';
import { createContext, useContext, useEffect, useReducer } from 'react';
import { SportsSeasonContext } from '../../../projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { rssHandlers, rssInitialState, rssReducer } from '../reducers/RssReducer';
import { ParentContext } from './ParentContext';
import { useRssFeed } from './useHelpers/useRssFeed';
import { AppTimestampContext } from './AppTimestampContext';
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext';

const _forceStale = false

/** Global Conversations for the Event */
export const RssContext = createContext();

/** Global Conversations for the Event */
const RssProvider = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, settings, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { homeSettings } = settings ?? {}
  const { mainFunctions, app_alts } = app_state
  const { altFunctions } = app_alts
  const { pathViews } = paps_state ?? {}
  const { districts } = pathViews ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { rssFeeds: rssFeeds_home } = homeSettings_global ?? {}

  const { appTimestamp_state } = useContext(AppTimestampContext) ?? {};
  const { timestampInfo } = appTimestamp_state ?? {};
  const { timestamps } = timestampInfo ?? {};
  const { rssFeedInfo } = timestamps ?? {};
  const _timestamp_feedInfo = rssFeedInfo?.[districts]

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)

  const mediaFeeds = _.get(sportsSeasonContext, 'sportsSeason_state.media_info.mediaFeeds')
  const sportsKey = _.get(sportsSeasonContext, 'sportsSeason_state.sportsKey')
  const _sportsYearAbr = _.get(sportsSeasonContext, 'sportsSeason_state._sportsYearAbr')
  const parentDataKeys = _.get(sportsSeasonContext, 'sportsSeason_state.parentDataKeys')

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { rssFeeders, rssFeeds } = district_data ?? {}

  const { getRssFeeds } = useRssFeed()

  // local state 
  const initState = rssInitialState({ fn_cls, mainFunctions, altFunctions, parentDataKeys, sportsKey, _sportsYearAbr, mediaFeeds, pathViews })
  const [rss_state, appUserData_dispatch] = useReducer(rssReducer, initState);
  const rss_handlers = rssHandlers(appUserData_dispatch)

  useEffect(() => {

    if (!_timestamp_feedInfo) return;

    const cb_feeds = (allFeeds) => {
      rss_handlers.handleSet_rssFeeds(allFeeds)
    }

    const THREE_HOURS = 3 * 60 * 60 * 1000
    const isStale = !_timestamp_feedInfo || Date.now() - _timestamp_feedInfo >= THREE_HOURS
    // if (isStale || _forceStale) {
    //   const _currentRssFeeders = _.mapValues(
    //     _.pickBy(rssFeeders, { active: true }),
    //     ({ _itemKey }) => rssFeeds_home?.[_itemKey]
    //   )
    //   getRssFeeds({ currentRssFeeders: _currentRssFeeders, callback: cb_feeds })
    // } else {
    //   cb_feeds(rssFeeds)
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathViews.sports, _timestamp_feedInfo, rssFeeds]);

  return <RssContext.Provider value={{ rss_state, rss_handlers }}>
    {props.children}
  </RssContext.Provider>
}

export default RssProvider